export const widgetFooterStyleProps = {
    alignItems: 'center',
    backgroundColor: 'background.white',
    display: 'flex',
    flexDirection: 'row',
    maxHeight: '72px',
    paddingY: '12px',
    paddingX: '16px',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'accent',
};

export const widgetFooterSecurityStyleProps = {
    display: {base: 'none', mobileXL: 'block'},
    marginLeft: 'auto',
    maxWidth: '73px',
    maxHeight: '40px',
};

export const widgetFooterTextStyleProps = {
    color: 'text.secondary.light',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: 2,
    padding: '0',
    sx: {
        a: {
            fontSize: 'inherit',
        },
    },
};

export const widgetFooterLogoStyleProps = {
    fill: 'primary.default',
    width: '60px',
    height: '60px',
    marginRight: '16px',
};
